<mat-checkbox
  (click)="onClick()"
  (change)="onChange($event)"
  [disabled]="disabled"
  [checked]="defaultValue"
  >{{ label }}</mat-checkbox
>
